export function getMortgageUiData() {
  return {
    personalOffersBadge: null,
    servicesBadge: null,
    personalOffersUrl:
      'https://www.cian.ru/ipoteka-main/?cian_source=cian&cian_medium=trap&cian_campaign=mortgage_button&cian_content=header_personal_offers',
    servicesUrl:
      'https://www.cian.ru/ipoteka-main/?cian_source=cian&cian_medium=trap&cian_campaign=mortgage_button&cian_content=header_service_mortgage',
    mobileRubricsUrl:
      'https://www.cian.ru/ipoteka-main/?cian_source=cian&cian_medium=trap&cian_campaign=mortgage_button&cian_content=mobweb_burger_mortgage_main',
    searcherMenuMortgageUrl:
      'https://www.cian.ru/ipoteka-main/?cian_source=cian&cian_medium=trap&cian_campaign=mortgage_button&cian_content=owner_lk_right_menu_button',
    searcherMenuMortgageStatusUrl:
      'https://www.cian.ru/mortgage/form/status?cian_source=cian&cian_medium=trap&cian_campaign=mortgage_button&cian_content=owner_lk_right_menu_button',
  };
}
